<template>
  <div class="page flex-v" @click="currDelI = null">
    <HeaderNav :topLevel="true" />
    <div :class="['container flex contaiBgSet', getMenuWay ? 'hasMenu' : '']">
      <div class="box flex-v">
        <div class="flex">
          <div class="menuBox" @click="jumpPage('book_ware')">
            <h2>语文教材</h2>
            <p>名家示范 精美朗读</p>
          </div>
          <div class="menuBox menuBox1" @click="jumpPage('book_library')">
            <h2>诵读资源</h2>
            <p>海量资源 拓展阅读</p>
          </div>
          <div class="moduleBox editBox">
            <div class="moduleTit flex">
              <p><span class="iconfont kuaijiecaidan"></span>快捷操作</p>
            </div>
            <div class="enterList flex">
              <div
                class="eItem flex-v"
                v-for="(item, i) in enterList"
                :key="i"
                @click="jumpPage(!i ? 'course_after' : 'course_manage')"
              >
                <p class="icon flex">
                  <img :src="item.icon" alt="" />
                </p>
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="moduleBox examBox">
          <div class="moduleTit flex">
            <p><span class="iconfont kehoulianxi"></span>课后练习</p>
            <p
              class="check"
              @click="jumpPage('course_after')"
              v-if="!examData.isEmpty"
            >
              查看详情<span class="iconfont gengduo"></span>
            </p>
          </div>
          <div class="eList flex hideScrollbar" v-if="!examData.isEmpty">
            <ul
              class="rList"
              v-infinite-scroll="loadMoreExams"
              :infinite-scroll-disabled="examData.loading || examData.lastPage"
            >
              <li
                v-for="(item, i) in examData.list"
                :key="item.homeworkId"
                class="rItem"
                @click="jumpPage('course_after', item.homeworkId)"
              >
                <div class="itemH flex">
                  <span class="lab">{{
                    item.type === 1 ? "朗读" : "背诵"
                  }}</span>
                  <div class="edit">
                    <img
                      class="icon"
                      src="~/images/edit.png"
                      alt=""
                      @click.stop="currDelI = i"
                    />
                    <p
                      class="delBox flex-center"
                      v-if="currDelI === i"
                      @click.stop="isShowDel = true"
                    >
                      <img class="del" src="~/images/删除@2x.png" alt="" />删除
                    </p>
                  </div>
                </div>
                <p class="line1 title">{{ item.title }}</p>
                <div class="bottInfo flex-center">
                  <p>
                    <span class="grade">{{ item.gradeOutput }}</span>
                    <span class="time">{{ item.createTime }}</span>
                  </p>
                  <div class="flex">
                    <p class="cItem flex-v">
                      <span class="num">{{ item.yesSubmitCount || 0 }}</span>
                      <span class="txt">已交</span>
                    </p>
                    <p class="cItem flex-v">
                      <span class="num">{{ item.noSubmitCount || 0 }}</span>
                      <span class="txt">未交</span>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <Empty
            title="还没有人提交练习作业哦～"
            tips="注：可在小程序-班级管理- 对学生进行作业提交提醒"
            v-else
          ></Empty>
        </div>
      </div>
      <div class="box flex-v box2">
        <div class="moduleBox dataBox flex-v">
          <div class="moduleTit flex">
            <p><span class="iconfont shuju"></span>班级数据</p>
            <Select
              style="flex: auto"
              v-model="classesId"
              placeholder="选择班级"
            >
              <Option
                v-for="item in classList"
                :key="item.id"
                :label="item.labelTxt"
                :value="item.id"
              ></Option>
            </Select>
          </div>
          <div class="dataBase flex">
            <div
              class="item flex-v"
              v-for="(value, key) of classesData"
              :key="key"
            >
              <h3>{{ dataObj[value] }}</h3>
              <p class="percent" :style="{ height: dataObj[value] + 'px' }"></p>
              <span>{{ key }}</span>
            </div>
          </div>
        </div>
        <div class="moduleBox remindBox">
          <div class="moduleTit flex">
            <p><span class="iconfont tixing"></span>事项提醒</p>
            <p class="check" v-if="!noticeData.isEmpty" @click="clear">
              <span class="iconfont shanchu"></span>清空
            </p>
          </div>
          <div
            class="list hideScrollbar"
            v-if="!noticeData.isEmpty"
            v-infinite-scroll="loadMoreNoti"
            :infinite-scroll-disabled="
              noticeData.loading || noticeData.lastPage
            "
          >
            <div class="item" v-for="(item, i) in noticeData.list" :key="i">
              <p class="flex wrap">
                <span class="time">{{ item.createTime }}</span>
                <button
                  v-text="item.homeworkId ? '去查阅' : '去处理'"
                  class="btn"
                  @click="handleRemind(item)"
                ></button>
              </p>
              <div class="flex wrap">
                <p class="flex left">
                  <span class="name line1 tNanme">{{ item.name }}</span>
                  <span class="txt"
                    >{{ item.eventType === 1 ? "申请加入" : "提交了" }}
                  </span>
                  <span class="name line1"
                    >{{ item.eventType === 1 ? item.school : item.title }}
                  </span>
                  <span class="txt" v-if="item.eventType === 2">练习</span>
                </p>
                <p class="grade">{{ item.gradeOutput }}</p>
              </div>
            </div>
          </div>
          <Empty title="还没有事项需要处理哦～" v-else></Empty>
        </div>
      </div>
    </div>
    <!-- 删除二次确认弹窗 -->
    <VMask v-model="isShowDel">
      <div class="delCont flex-v" @click.stop="">
        <h2>确认删除任务</h2>
        <p>删除后，该练习任务的报告记录将会清空！</p>
        <div class="btnBox flex">
          <span class="cancel" @click="cancel">取消</span>
          <span class="sure" @click="sure">确认删除</span>
        </div>
      </div>
    </VMask>
    <!-- 入班审核 -->
    <Verify ref="verifyRef" />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import Empty from "business/Empty";
import VMask from "base/mask";
import util from "libs/util";
import Verify from "./../manage/verify.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Select,
    Option,
    Empty,
    VMask,
    Verify,
  },
  data() {
    return {
      enterList: [
        {
          icon: "https://llss-file.langsounds.com/miniapp/a194e19c8b035698e2ec03c739fb26c5.png",
          name: "布置练习",
        },
        {
          icon: "https://llss-file.langsounds.com/miniapp/417b09b7d37771ca055836f8500cfe72.png",
          name: "邀请学生",
        },
        {
          icon: "https://llss-file.langsounds.com/miniapp/633e5bb7e5fe3f16607c95ce66e84308.png",
          name: "班级管理",
        },
      ],
      classesId: 0,
      classesData: {
        已布置练习: "homeWorkTotal",
        学生朗读次数: "studnetReadTotal",
        学生背诵次数: "studnetReciteTotal",
      },
      dataObj: {}, // 班级数据
      count: 6,
      currDelI: null,
      currGradeItem: {},
      isShowDel: false,
      examData: {
        // 课后作业
        pageNum: 1,
        list: [],
        lastPage: true,
        loading: false,
        isEmpty: false,
      },
      noticeData: {
        // 事项提醒
        pageNum: 1,
        list: [],
        lastPage: true,
        loading: false,
        isEmpty: false,
      },
      classList: [],
    };
  },
  computed: {
    ...mapGetters(["getMenuWay"]),
  },
  watch: {
    classesId(val) {
      console.log(val);
      this.loadClassData();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadClassList();
      this.loadClassData();
      this.loadExamList();
      this.loadNotice();
    },
    jumpPage(name, id) {
      let params = {};
      if (name === "book_ware")
        params = { id: util.getStorage("LLSH_LAST_WARE") };
      if (id)
        params = {
          id,
          home: true,
        };
      this.$gopage(name, params);
    },

    handleRemind({ classesId, homeworkId }) {
      if (homeworkId) return this.$gopage("course_after", { id: homeworkId });
      return (this.$refs.verifyRef.status = true);
    },

    cancel() {
      this.isShowDel = false;
      this.currDelI = null;
    },
    async sure() {
      this.$loading.show();
      this.isShowDel = false;
      const res = await this.$get("/homework/del.json", {
        homeworkId: this.examData.list[this.currDelI].homeworkId,
      });
      if (res.status == 200) {
        console.log(this.currDelI);
        this.examData.list.splice(this.currDelI, 1);
        console.log(this.examData.list);
        this.$toast("删除成功！");
      } else {
        this.$toast(res.message);
      }
      this.$loading.hide();
      this.examData.isEmpty = !this.examData.list.length;
      this.currDelI = null;
    },

    // 获取课后练习
    async loadExamList() {
      const { pageNum, list } = this.examData;
      const res = await this.$post("/home/homeworkList.json", {
        pageNum,
        pageSize: 10,
      });
      console.log("------课后练习列表----", res);
      if ((res.status = "200")) {
        if (res.data?.list) {
          res.data.list.map((item) => {
            item.gradeOutput = item?.classesName?.includes("年级")
              ? item.classesName
              : util.gradeNumToText(item.grade) + item.classesName;
          });
        }
        this.examData = {
          ...this.examData,
          list: [...list, ...res.data.list],
          lastPage: res.data.lastPage,
          loading: false,
        };
        this.examData.isEmpty = !this.examData.list.length;
      }
    },

    // 班级列表
    async loadClassList() {
      const cRes = await this.$post("/home/classesList.json", {});
      if (cRes.status == "200") {
        cRes.data?.length &&
          cRes.data.map((item) => {
            item.labelTxt = `${item.school} - ${
              item?.name?.includes("年级")
                ? item.name
                : util.gradeNumToText(item.grade) + item.name
            }`;
          });
        this.classList = [{ id: 0, labelTxt: "全部" }, ...cRes.data];
      }
      console.log("--班级liebi---", cRes);
    },

    // 班级数据
    async loadClassData() {
      const res = await this.$post("/home/homeWorkData.json", {
        classesId: this.classesId || 0,
      });
      console.log("--班级数据---", res);
      if (res.status == "200") this.dataObj = res.data;
    },

    // 清空事项
    async clear() {
      let ids = [];
      const { list } = this.noticeData;
      list.filter((item) => {
        ids.push(item.id);
      });
      const res = await this.$post("/home/clearEvent.json", {
        ids: ids.join(",") || "",
      });
      if (res.status == "200") this.loadNotice(true);
      else this.$toast("清空失败");
    },

    // 获取事项提醒列表
    async loadNotice(isReset = false) {
      if (isReset) {
        this.noticeData = {
          ...this.noticeData,
          pageNum: 1,
          list: [],
        };
      }
      let { pageNum, list } = this.noticeData;
      const res = await this.$post("/home/eventItemRemindList.json", {
        pageNum,
        pageSize: 10,
      });
      console.log("---resres---", res);
      if (res.status == "200") {
        if (res?.data?.list) {
          res.data.list.map((item) => {
            item.gradeOutput =
              util.gradeNumToText(item.grade) + item.classesName;
            return item;
          });
        }
        this.noticeData = {
          ...this.noticeData,
          list: [...list, ...res.data.list],
          lastPage: res.data.lastPage,
          loading: false,
        };
        this.noticeData.isEmpty = !this.noticeData.list.length;
      }
    },
    // 加载更多
    loadMoreNoti() {
      this.noticeData.loading = true;
      if (!this.noticeData.lastPage) {
        this.noticeData.pageNum++;
        this.loadNotice();
      }
    },
    loadMoreExams() {
      this.examData.loading = true;
      if (!this.examData.lastPage) {
        this.examData.pageNum++;
        this.loadExamList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~styles/book/taskItem.less";
.container {
  padding-top: 1.5%;
  overflow-y: auto;
}

.box {
  margin-left: 40px;
  width: 61%;

  &.box2 {
    width: 39%;
  }

  .menuBox {
    // width: 256px;
    width: 24%;
    height: 329px;
    background: url("~images/编组 38@2x(1).png") no-repeat;
    background-size: cover;
    padding: 33px 45px;
    box-sizing: border-box;
    margin-right: 1%;
    flex-shrink: 0;
    border-radius: 40px 40px 0px 40px;

    h2 {
      color: #0091ff;
      font-size: 24px;
      font-weight: bold;
      white-space: nowrap;
    }

    p {
      color: #666666;
      font-size: 16px;
      line-height: 34px;
    }

    &.menuBox1 {
      background: url("~images/编组 39@2x(1).png") no-repeat;
      background-size: cover;

      h2 {
        color: #fa8700;
      }
    }
  }

  .moduleTit {
    color: #333333;
    font-size: 24px;
    align-items: center;
    justify-content: space-between;

    .iconfont {
      color: #FB7C33;
      font-size: 26px;
      margin-right: 10px;
    }

    .check {
      color: #666666;
      font-size: 20px;
      cursor: pointer;

      .iconfont {
        color: #666666;
        font-size: 20px;
        margin-right: 0;
      }
    }
  }

  .moduleBox {
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 12px 14px -4px rgba(0, 0, 0, 0.06);
    border-radius: 21px;
    backdrop-filter: blur(3px);
    padding: 32px;
    box-sizing: border-box;
  }

  .editBox {
    width: 50%;
    // width: 500px;
    height: 300px;
    margin-left: 13px;

    .enterList {
      width: 100%;
      justify-content: space-between;
      margin-top: 23px;

      .eItem {
        color: #333333;
        font-size: 20px;
        align-items: center;
        width: 30%;

        .icon {
          // width: 130px;
          // height: 130px;
          width: 100%;
          height: 130px;
          background: #ffffff;
          box-shadow: 0px 12px 14px -4px rgba(0, 0, 0, 0.06),
            inset 0px -4px 1px 0px rgba(243, 228, 218, 0.6);
          border-radius: 8px;
          margin-bottom: 20px;
          justify-content: center;
          align-items: center;

          img {
            width: 60px;
            height: 60px;
          }
        }
      }
    }
  }
  .examBox {
    // width: 1040px;
    width: 100%;
    height: 526px;
    margin-left: 13px;
    background: rgba(255, 255, 255, 0.5);
    margin-top: 11px;
    padding-left: 22px;

    .moduleTit {
      margin-left: 10px;
    }

    .eList {
      max-height: calc(100% - 47px);
      margin-top: 25px;
      overflow: auto;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      .empty {
        margin-top: 80px;
      }

      .rList {
        width: 100%;
      }

      .rItem {
        // width: 308px;
        height: 131px;
        width: 31%;
        border-radius: 6px;
        margin: 0 0.8% 20px;
        padding: 13px 15px 16px 19px;
        box-sizing: border-box;
        box-shadow: 0rpx 2rpx 3rpx 0rpx rgba(0, 0, 0, 0.1);

        // &:nth-child(3n) {
        //   margin-right: 0;
        // }

        .lab {
          padding: 2px 7px;
          box-sizing: border-box;
          font-size: 11px;
        }

        .icon {
          width: 26px;
          height: 26px;
        }

        .delBox {
          width: 80px;
          height: 37px;
          font-size: 10px;
          padding-right: 10px;
          box-sizing: border-box;
          z-index: 1;

          .del {
            width: 12px;
            height: 11px;
            margin-right: 4px;
          }
        }

        .title {
          font-size: 15px;
        }

        .grade,
        .txt {
          font-size: 11px;
        }

        .time {
          font-size: 9px;
          white-space: nowrap;
        }

        .num {
          font-size: 18px;
        }

        .cItem {
          min-width: 50px;
        }
      }
    }
  }

  .dataBox {
    // width: 559px;
    width: 85%;
    height: 300px;
    background: #ffffff;
    margin-bottom: 40px;

    .moduleTit {
      p {
        flex-shrink: 0;
        margin-right: 40px;
      }
    }

    .dataBase {
      width: 100%;
      flex: auto;
      margin-top: 30px;
      justify-content: space-around;
      align-items: flex-end;

      .item {
        align-items: center;
        h3 {
          color: #FB7C33;
          font-size: 30px;
          flex-shrink: 0;
        }

        .percent {
          width: 13px;
          min-height: 5px;
          max-height: 100px;
          background: linear-gradient(
            180deg,
            #ffb000 0%,
            rgba(255, 203, 36, 0) 100%
          );
          margin: 10px 0;
        }

        span {
          color: #666666;
          font-size: 16px;
          flex-shrink: 0;
        }
      }
    }
  }

  .remindBox {
    // width: 559px;
    width: 85%;
    height: 526px;
    background: linear-gradient(180deg, #fffefc 0%, #fffcf7 100%);
    box-shadow: 0px 16 18px -5px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    .list {
      height: calc(100% - 47px);
      overflow-y: auto;
      margin-top: 15px;

      .item {
        padding: 12px 0 0;
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;
        font-size: 15px;
        color: #333333;

        .wrap {
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .left {
            flex: auto;
            overflow: hidden;
            margin-right: 15px;

            span {
              white-space: nowrap;
              margin-right: 3px;
            }
          }

          .time {
            color: #999999;
            font-size: 14px;
          }

          .tNanme {
            max-width: 150px;
            flex-shrink: 0;
          }

          .btn {
            width: 77px;
            height: 33px;
            background: #ffffff;
            border-radius: 5px;
            border: 1px solid #eeeeee;
            color: #FB7C33;
          }

          .txt {
            color: #999999;
          }

          .grade {
            flex-shrink: 0;
          }
        }
      }
    }
  }
}
</style>
